import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

import { fetchProfile } from "../../slices/thunks";
// Import avatar image
import avatar1 from "../../assets/images/users/avatar-1.jpg";

const ProfileDropdown = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadProfile = async () => {
      setIsLoading(true);
      try {
        await dispatch(fetchProfile());
      } catch (error) {
        console.error("Failed to fetch profile:", error);
      } finally {
        setIsLoading(false);
      }
    };
    loadProfile();
  }, [dispatch]);

  const user = useSelector((state) => state.Profile.user);

  // Safely construct user name - FIXED
  const getUserName = () => {
    if (isLoading) return "Loading...";

    if (!user) return "User";

    // Check if user has the expected structure
    if (user.data) {
      // If user comes from API response with data property
      const userData = user.data;
      const firstName = userData.firstname || userData.firstName || "";
      const lastName = userData.lastname || userData.lastName || "";
      const name = `${firstName} ${lastName}`.trim();
      return name || userData.username || userData.email || "User";
    } else {
      // If user is the data object directly
      const firstName = user.firstname || user.firstName || "";
      const lastName = user.lastname || user.lastName || "";
      const name = `${firstName} ${lastName}`.trim();
      return name || user.username || user.email || "User";
    }
  };

  const userName = getUserName();

  // Get profile image URL
  const getProfileImageUrl = (imagePath) => {
    if (!imagePath) return avatar1;

    // If it's already a full URL, return as is
    if (imagePath.startsWith('http')) {
      return imagePath;
    }

    // Remove leading slash if present to avoid double slashes
    const cleanPath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;

    // Construct full URL using environment variable
    const baseUrl = process.env.REACT_APP_API_URL || "http://192.168.29.223:3001/";
    return `${baseUrl}${cleanPath}`;
  };

  // Get user data (handles both nested and flat structures)
  const getUserData = () => {
    return user?.data || user || {};
  };

  const userData = getUserData();

  // Get the profile image source
  const profileImageSrc = userData?.profileimg
    ? getProfileImageUrl(userData.profileimg)
    : userData?.profileImage
      ? getProfileImageUrl(userData.profileImage)
      : userData?.avatar
        ? getProfileImageUrl(userData.avatar)
        : userData?.image
          ? getProfileImageUrl(userData.image)
          : avatar1;

  // Dropdown Toggle
  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };

  return (
    <Dropdown
      isOpen={isProfileDropdown}
      toggle={toggleProfileDropdown}
      className="ms-sm-3 header-item topbar-user"
    >
      <DropdownToggle tag="button" type="button" className="btn">
        <span className="d-flex align-items-center">
          <img
            className="rounded-circle header-profile-user"
            src={profileImageSrc}
            alt="Profile Avatar"
            onError={(e) => {
              // If profile image fails to load, fall back to default avatar
              if (e.target.src !== avatar1) {
                e.target.src = avatar1;
                e.target.onerror = null; // Prevent infinite loop
              }
            }}
          />
          <span className="text-start ms-xl-2">
            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
              {userName}
            </span>
            {isLoading && (
              <span className="ms-1 spinner-border spinner-border-sm" role="status">
                <span className="visually-hidden">Loading...</span>
              </span>
            )}
          </span>
        </span>
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu-end">
        <h6 className="dropdown-header">Welcome {userName}!</h6>
        <DropdownItem className="p-0">
          <Link to="/profile" className="dropdown-item">
            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
            <span className="align-middle">Profile</span>
          </Link>
        </DropdownItem>
        <div className="dropdown-divider"></div>
        <DropdownItem className="p-0">
          <Link to="/logout" className="dropdown-item">
            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
            <span className="align-middle">Logout</span>
          </Link>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default ProfileDropdown;